import { FaqState } from '@/typings/reducer';
import { FAQModifyAction, FAQ_TYPE } from './actionType';

const INITIAL_STATE: FaqState = {
    disabled_stage: false,
    can_faq: false,
    hot_faq: [],
    hot_label: [],
    un_solve_reason: [],
    log_id: '0',
    welcome: '',
    dify_query_params: {},
    model: '',
    request_type: 2,
    no_answer_count: 0,
    transfer_human_threshold: 0,
    flow: 1,
    workflow_log: 1
};
const actionHandler: FAQModifyAction = {
    [FAQ_TYPE.SET_FAQ_SESSION]: (state, payload) => ({
        ...state,
        ...payload,
        label_list: payload?.hot_label || [],
        hot_faq: payload?.hot_faq?.map((item) => ({ ...item, log_id: payload.log_id })) || []
    }),
    [FAQ_TYPE.CHANGE_FAQ_STATUS]: (state, payload) => ({
        ...state,
        can_faq: payload
    }),

    [FAQ_TYPE.SET_STAGE_CLICK]: (state, payload) => ({
        ...state,
        disabled_stage: payload
    }),

    [FAQ_TYPE.RELOAD_FAQ]: (state) => ({
        ...state,
        disabled_stage: false,
        can_faq: true
    }),
    [FAQ_TYPE.SET_DEFAULT_STATE]: () => INITIAL_STATE,
    [FAQ_TYPE.UPDATE_NO_ANSWER_COUNT]: (state, payload: number) => ({
        ...state,
        no_answer_count: payload
    })
};

export default function faq(
    state = INITIAL_STATE,
    action: { type: string; payload: any }
): FaqState {
    return actionHandler[action.type] ? actionHandler[action.type](state, action.payload) : state;
}
